import React, { useContext } from "react";

import ThemeContext from "~/common/ThemeContext";
import { FeedbackContext } from "~/nav/panels/Feedback";
import { FEEDBACK_CATEGORY_VALUES } from "~/nav/panels/Feedback/CategoryDropdown";
import CreateFeedbackButton from "~/nav/panels/Feedback/CreateFeedbackButton";
import { ReactComponent as StartNewFeedback } from "~/nav/panels/Feedback/StartNewFeedback.svg";
import { ReactComponent as StartNewFeedbackDark } from "~/nav/panels/Feedback/StartNewFeedbackDark.svg";
import { Button } from "~/ui";

import styles from "./EmptyState.module.css";

export default function CreateNewFeedbackIllustration({
	hasAccessToFeedback,
	hasAccessTo360Feedback,
}: {
	hasAccessToFeedback: boolean;
	hasAccessTo360Feedback: boolean;
}) {
	const { view, type, about, from, resetFilters } = useContext(FeedbackContext);
	const showIllustration = view === FEEDBACK_CATEGORY_VALUES.INBOX && !type && !about && !from;

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				{showIllustration ? (
					<>
						<ThemeContext.Consumer>
							{({ isDarkMode }) =>
								isDarkMode ? (
									<StartNewFeedbackDark className={styles.createNewIll} />
								) : (
									<StartNewFeedback className={styles.createNewIll} />
								)
							}
						</ThemeContext.Consumer>
						<div className={styles.title}>Start new feedback</div>
						<div className={styles.description}>
							Exchange feedback about yourself, someone on your team, meetings you organize, or anything at all.
						</div>
						<CreateFeedbackButton
							triggerText="New feedback"
							hasAccessToFeedback={hasAccessToFeedback}
							hasAccessTo360Feedback={hasAccessTo360Feedback}
						/>
					</>
				) : (
					<>
						<div className={styles.title}>No results found</div>
						<div className={styles.description}>It seems we can&apos;t find any feedback based on your filters.</div>
						{(type || from || about) && (
							<Button size="wide" className={styles.filtersButton} onClick={resetFilters}>
								Reset filters
							</Button>
						)}
					</>
				)}
			</div>
		</div>
	);
}
